import * as PropTypes from 'prop-types';
import * as React from 'react';
import { FelaTheme } from 'react-fela';

/**
 * A ProviderConsumer is used to consume Fluent UI context from Provider.
 */
var ProviderConsumer = function ProviderConsumer(_ref) {
  var render = _ref.render;
  return React.createElement(FelaTheme, null, function (context) {
    return render(context.theme);
  });
};

ProviderConsumer.displayName = 'ProviderConsumer';
ProviderConsumer.propTypes = {
  render: PropTypes.func.isRequired
};
export default ProviderConsumer;
//# sourceMappingURL=ProviderConsumer.js.map
